import { render, staticRenderFns } from "./AllTickets.vue?vue&type=template&id=0de2bcb2&"
import script from "./AllTickets.vue?vue&type=script&lang=js&"
export * from "./AllTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports